interface BrandList {
    smtps: string[];
    tier3Smtps: string[];
}

export enum BrandListLoadState {
    unloaded,
    loading,
    loadSucceeded,
    loadFailed,
}

export default BrandList;
